'use strict';

var _vue = require('vue');

var _vue2 = _interopRequireDefault(_vue);

var _vueRouter = require('vue-router');

var _vueRouter2 = _interopRequireDefault(_vueRouter);

var _mintUi = require('mint-ui');

var _mintUi2 = _interopRequireDefault(_mintUi);

var _vTooltip = require('v-tooltip');

var _vTooltip2 = _interopRequireDefault(_vTooltip);

var _vueClipboard = require('vue-clipboard2');

var _vueClipboard2 = _interopRequireDefault(_vueClipboard);

require('vant/lib/index.css');

var _vant = require('vant');

var _vant2 = _interopRequireDefault(_vant);

var _vueDirectiveImagePreviewer = require('vue-directive-image-previewer');

var _vueDirectiveImagePreviewer2 = _interopRequireDefault(_vueDirectiveImagePreviewer);

var _api = require('./api');

var _api2 = _interopRequireDefault(_api);

require('mint-ui/lib/style.css');

require('vue-directive-image-previewer/dist/assets/style.css');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.use(_vTooltip2.default); /**
                                        * @file 插件
                                        */

_vue2.default.use(_vueClipboard2.default);
_vue2.default.use(_vueRouter2.default);
_vue2.default.use(_vueDirectiveImagePreviewer2.default);
_vue2.default.use(_mintUi2.default);
_vue2.default.use(_api2.default);
_vue2.default.use(_vant2.default);


//////////////////
// WEBPACK FOOTER
// ./src/plugins/index.js
// module id = 456
// module chunks = 14